import { HrPrimary } from '@components/styles/hr-styles';
import styled from 'styled-components';

export const ToastContainer = styled.div`
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${({ color }) => color || HrPrimary};
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-family: 'Open Sans', sans-serif;
`;

export const IconWrapper = styled.span`
  font-size: 2rem;
`;
